module.exports = __webpack_public_path__ + "static/filament-852abd6c3f1a8935b1df9a64b6d72f63.jpg";